import { MerchandisingPopupService } from './merchandising-popup.service';

export default angular
  .module('sfMobile.services.merchandising-popup', [
    'pascalprecht.translate',
    'sfMobile.services.popup',
    'sfMobile.services.popup-request',
  ])
  .service('merchandisingPopupService', MerchandisingPopupService).name;
